import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checkmark",
  "use": "checkmark-usage",
  "viewBox": "0 0 168 168",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 168 168\" id=\"checkmark\"><circle cx=\"84\" cy=\"84\" r=\"84\" fill=\"#E5F5E8\" /><path d=\"M82.2 103.879l-17.04-17.04a3.983 3.983 0 010-5.64 3.983 3.983 0 015.64 0l10.96 10.96 23.2-26.76c1.44-1.68 3.96-1.84 5.64-.4 1.68 1.44 1.84 3.96.4 5.64l-28.8 33.24z\" fill=\"#00AB44\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol